import React from 'react';
import AnimateHeight from 'react-animate-height';

export type CollapsibleProps = {
  isOpened: boolean;
  animationTimeMs?: number;
  delayTimeMs?: number;
  animateOpacity?: boolean;
  role?: string;
  id?: string;
  'aria-labelledby'?: string;
  children?: React.ReactNode;
};

const Collapsible: React.FC<CollapsibleProps> = ({
  children,
  isOpened,
  animationTimeMs,
  delayTimeMs,
  animateOpacity,
  role,
  id,
  'aria-labelledby': ariaLabelledBy,
}) => (
  <AnimateHeight
    duration={animationTimeMs ?? 600}
    delay={delayTimeMs}
    height={isOpened ? 'auto' : 0}
    animateOpacity={animateOpacity}
    role={role}
    id={id}
    aria-labelledby={ariaLabelledBy}>
    {children}
  </AnimateHeight>
);

export default Collapsible;
